export default {
  settings: (state) => {
    return state.settings;
  },

  workStations: (state) => {
    return state.workStations;
  },
  workStationCode: (state) => {
    return state.workStationCode;
  },

  workShifts: (state) => {
    return state.workShifts;
  },

  workShiftCode: (state) => {
    return state.workShiftCode;
  },

  boms: (state) => {
    return state.boms;
  },
  bom: (state) => {
    return state.bom;
  },

  bomCode: (state) => {
    return state.bomCode;
  },

  bomCommodities: (state) => {
    return state.bomCommodities;
  },

  orders: (state) => {
    return state.orders;
  },
  order: (state) => {
    return state.order;
  },

  orderCode: (state) => {
    return state.orderCode;
  },

  orderDetails: (state) => {
    return state.orderDetails;
  },

  ordersSetting: (state) => {
    return state.ordersSetting;
  },
  orderSetting: (state) => {
    return state.orderSetting;
  },

  foilCartable: (state) => {
    return state.foilCartable;
  },

  financialProductionCartable: (state) => {
    return state.financialProductionCartable;
  },

  casterCartable: (state) => {
    return state.casterCartable;
  },

  coldRollCartable: (state) => {
    return state.coldRollCartable;
  },

  saleCartable: (state) => {
    return state.saleCartable;
  },

  managerProductionCartable: (state) => {
    return state.managerProductionCartable;
  },

  productionCartable: (state) => {
    return state.productionCartable;
  },

  supplyAndEquipmentCartable: (state) => {
    return state.supplyAndEquipmentCartable;
  },

  managerSupplyCartable: (state) => {
    return state.managerSupplyCartable;
  },

  financialSupplyCartable: (state) => {
    return state.financialSupplyCartable;
  },

  orderDetailConfirmLog: (state) => {
    return state.orderDetailConfirmLog;
  },

  reqProduces: (state) => {
    return state.reqProduces;
  },
  reqProduce: (state) => {
    return state.reqProduce;
  },

  reqProduceDetails: (state) => {
    return state.reqProduceDetails;
  },

  reqProduceCode: (state) => {
    return state.reqProduceCode;
  },

  produceOrderFinancialCartable: (state) => {
    return state.produceOrderFinancialCartable;
  },

  produceOrderManagerCartable: (state) => {
    return state.produceOrderManagerCartable;
  },

  produceOrderProcessCartable: (state) => {
    return state.produceOrderProcessCartable;
  },

  produceProcesses: (state) => {
    return state.produceProcesses;
  },
  produceProcess: (state) => {
    return state.produceProcess;
  },

  productionReports: (state) => {
    return state.productionReports;
  },
  productionReport: (state) => {
    return state.productionReport;
  },
  casterProductionReports: (state) => {
    return state.casterProductionReports;
  },

  productionReportCode: (state) => {
    return state.productionReportCode;
  },

  productionReportCoilNumber: (state) => {
    return state.productionReportCoilNumber;
  },

  productionReportMaterials: (state) => {
    return state.productionReportMaterials;
  },

  productionReportReadonlyFields: (state) => {
    return state.productionReportReadonlyFields;
  },

  processTypes: (state) => {
    return state.processTypes;
  },

  produceOrders: (state) => {
    return state.produceOrders;
  },
  produceOrder: (state) => {
    return state.produceOrder;
  },

  produceOrderCode: (state) => {
    return state.produceOrderCode;
  },

  produceOrderCartable: (state) => {
    return state.produceOrderCartable;
  },

  sprints: (state) => {
    return state.sprints;
  },

  sprintCode: (state) => {
    return state.sprintCode;
  },

  currentSprint: (state) => {
    return state.currentSprint;
  },

  coilCertificates: (state) => {
    return state.coilCertificates;
  },
  coilCertificate: (state) => {
    return state.coilCertificate;
  },

  coilCertificateCode: (state) => {
    return state.coilCertificateCode;
  },

  coldRollingProductionReports: (state) => {
    return state.coldRollingProductionReports;
  },

  foilRollingProductionReports: (state) => {
    return state.foilRollingProductionReports;
  },

  qcCasters: (state) => {
    return state.qcCasters;
  },

  qcColdRollings: (state) => {
    return state.qcColdRollings;
  },

  qcFoilRollings: (state) => {
    return state.qcFoilRollings;
  },

  orderCommodity: (state) => {
    return state.orderCommodity;
  },

  hardnesses: (state) => {
    return state.hardnesses;
  },
  hardnessCode: (state) => {
    return state.hardnessCode;
  },

  productSurfaces: (state) => {
    return state.productSurfaces;
  },
  productSurfaceCode: (state) => {
    return state.productSurfaceCode;
  },

  usageGroups: (state) => {
    return state.usageGroups;
  },
  usageGroupCode: (state) => {
    return state.usageGroupCode;
  },

  foilUsages: (state) => {
    return state.foilUsages;
  },
  foilUsageCode: (state) => {
    return state.foilUsageCode;
  },

  innerCoreDiameters: (state) => {
    return state.innerCoreDiameters;
  },
  innerCoreDiameterCode: (state) => {
    return state.innerCoreDiameterCode;
  },

  produceOrderCastings: (state) => {
    return state.produceOrderCastings;
  },

  cartableCasting: (state) => {
    return state.cartableCasting;
  },

  cartableColdRolling: (state) => {
    return state.cartableColdRolling;
  },

  cartableFoilRolling: (state) => {
    return state.cartableFoilRolling;
  },

  managementCartableCasting: (state) => {
    return state.managementCartableCasting;
  },

  managementCartableColdRolling: (state) => {
    return state.managementCartableColdRolling;
  },

  managementCartableFoilRolling: (state) => {
    return state.managementCartableFoilRolling;
  },

  printLink: (state) => {
    return state.printLink;
  },

  produceOrderColdRollings: (state) => {
    return state.produceOrderColdRollings;
  },

  produceOrderFoilRollings: (state) => {
    return state.produceOrderFoilRollings;
  },

  furnaces: (state) => {
    return state.furnaces;
  },
  furnace: (state) => {
    return state.furnace;
  },
  furnaceCode: (state) => {
    return state.furnaceCode;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },
};
